// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  position: relative;
  width: 100%;
  /* max-width: 300px; */
}

.dropdown-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  background: #FFFDFC;
  font-size: 1.6rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

/* Variant styles */
.dropdown.default .dropdown-toggle {
  border: 1px solid #2C3948;
  border-radius: 4px;
}

.dropdown.bordered .dropdown-toggle {
  border: 1px solid #E5E7EB;
  border-radius: 4px;
}

.dropdown.minimal .dropdown-toggle {
  border: none;
  background: transparent;
  padding: 8px;
}

/* Arrow icon */
.dropdown-arrow {
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

.dropdown.open .dropdown-arrow {
  transform: rotate(180deg);
}

/* Dropdown menu */
.dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: #FFFDFC;
  border: 1px solid #E5E7EB;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  z-index: 10;
}

.dropdown-item {
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.dropdown-item:hover {
  background-color: rgba(229, 231, 235, 0.5);
}

.dropdown-item.active {
  background-color: rgba(218, 112, 39, 0.1);
  color: #DA7027;
}`, "",{"version":3,"sources":["webpack://./src/composants/DropDown/DropDown.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,6CAA6C;EAC7C,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB","sourcesContent":[".dropdown {\r\n  position: relative;\r\n  width: 100%;\r\n  /* max-width: 300px; */\r\n}\r\n\r\n.dropdown-toggle {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  background: #FFFDFC;\r\n  font-size: 1.6rem;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n/* Variant styles */\r\n.dropdown.default .dropdown-toggle {\r\n  border: 1px solid #2C3948;\r\n  border-radius: 4px;\r\n}\r\n\r\n.dropdown.bordered .dropdown-toggle {\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 4px;\r\n}\r\n\r\n.dropdown.minimal .dropdown-toggle {\r\n  border: none;\r\n  background: transparent;\r\n  padding: 8px;\r\n}\r\n\r\n/* Arrow icon */\r\n.dropdown-arrow {\r\n  width: 16px;\r\n  height: 16px;\r\n  transition: transform 0.2s ease;\r\n}\r\n\r\n.dropdown.open .dropdown-arrow {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n/* Dropdown menu */\r\n.dropdown-menu {\r\n  position: absolute;\r\n  top: calc(100% + 4px);\r\n  left: 0;\r\n  right: 0;\r\n  background: #FFFDFC;\r\n  border: 1px solid #E5E7EB;\r\n  border-radius: 4px;\r\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\r\n  z-index: 10;\r\n}\r\n\r\n.dropdown-item {\r\n  width: 100%;\r\n  padding: 12px 16px;\r\n  border: none;\r\n  background: none;\r\n  text-align: left;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background-color: rgba(229, 231, 235, 0.5);\r\n}\r\n\r\n.dropdown-item.active {\r\n  background-color: rgba(218, 112, 39, 0.1);\r\n  color: #DA7027;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
